module.exports = __webpack_public_path__ + "static/media/uni-logo.370502ef.png";